type CurrencyName = "USD" | "CLP"

const currenciesConfiguration = {
  "USD": {
    locale: "en-US",
    decimals: 2
  },
  "CLP": {
    locale: "es-CL",
    decimals: 0
  }
}

export const formatToCurrencyUtil = (value: number, currency: CurrencyName, decimals?: number) => {
  const config = currenciesConfiguration[currency]
  const formatter = new Intl.NumberFormat(config.locale, {
    style: "currency",
    currency,
    currencyDisplay: "code",
    minimumFractionDigits: decimals ?? config.decimals,
    maximumFractionDigits: decimals ?? config.decimals
  })
  return formatter.format(value)
}
